import { render } from "./ModalNewAzienda.vue?vue&type=template&id=493b33f3&scoped=true"
import script from "./ModalNewAzienda.vue?vue&type=script&lang=js"
export * from "./ModalNewAzienda.vue?vue&type=script&lang=js"

import "./ModalNewAzienda.vue?vue&type=style&index=0&id=493b33f3&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493b33f3"]])

export default __exports__